import {useMix} from '../../../fields/mix/useMix'

/**
 * Resolves the org unit to use for Order Intake slot requests.
 *
 * The provider-level `config.orgUnitId` is captured once when the process starts and does not
 * update when the user later picks/changes a contract in the Quote step. The currently selected
 * form contract (if any) always reflects the user's latest choice, so it takes precedence.
 */
export const useOrderIntakeSlotOrgUnitId = (configOrgUnitId: string): string => {
  const {selectedContract} = useMix()
  return selectedContract?.orgUnitId || configOrgUnitId
}
